(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloom-health-hub-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeJourney = (scope = document) => {
      scope.querySelectorAll('.bloom-health-v2').forEach((journey) => {
        if (journey.dataset.practiceReady === 'true') return;
        journey.dataset.practiceReady = 'true';
        const mobile = window.matchMedia('(max-width: 760px)');
        const synchronize = () => {
          journey.querySelectorAll('[data-journey-practice]').forEach((practice) => {
            practice.open = !mobile.matches;
          });
        };
        synchronize();
        mobile.addEventListener('change', synchronize);
      });
    };
    initializeJourney();
    document.addEventListener('shopify:section:load', (event) => initializeJourney(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class BloomCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.submitting = false;
      this.form = this.querySelector('.bloom-cart-form');
      this.updateButton = this.querySelector('[data-cart-update]');
      this.updateTimer = null;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-change]');
        if (!button) return;

        const item = button.closest('[data-cart-item]');
        const input = item?.querySelector('[data-quantity-input]');
        if (!input) return;

        const delta = Number(button.dataset.quantityChange);
        const current = Number.parseInt(input.value, 10) || 0;
        input.value = String(Math.max(0, current + delta));
        this.scheduleUpdate();
      });

      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-quantity-input]')) return;
        event.target.value = String(Math.max(0, Number.parseInt(event.target.value, 10) || 0));
        this.scheduleUpdate();
      });

      this.form?.addEventListener('submit', (event) => {
        window.clearTimeout(this.updateTimer);
        if (this.submitting) {
          event.preventDefault();
          return;
        }
        this.submitting = true;
        this.form.setAttribute('aria-busy', 'true');
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        this.submitting = false;
        this.form?.removeAttribute('aria-busy');
      });
    }

    disconnectedCallback() {
      window.clearTimeout(this.updateTimer);
    }

    scheduleUpdate() {
      if (this.submitting) return;
      window.clearTimeout(this.updateTimer);
      this.updateTimer = window.setTimeout(() => {
        this.form?.requestSubmit(this.updateButton);
      }, 350);
    }
  }

  if (!customElements.get('bloom-cart')) {
    customElements.define('bloom-cart', BloomCart);
  }

  } catch(e) { console.error(e); }
})();
})();
